import { render, staticRenderFns } from "./BpmnPanel.vue?vue&type=template&id=15681290&scoped=true&"
import script from "./BpmnPanel.vue?vue&type=script&lang=js&"
export * from "./BpmnPanel.vue?vue&type=script&lang=js&"
import style0 from "./BpmnPanel.vue?vue&type=style&index=0&id=15681290&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15681290",
  null
  
)

export default component.exports